import {
  Rule,
  UserReqRulesSchema,
  UserRequirementInclusionType,
  UserRequirementType,
} from '@youshift/shared/types';

export interface UserConfig extends UserReqRulesSchema {
  name: string;
  included: boolean;
}

export interface RoleConfig {
  users: UserConfig[];
  role_name: string;
}

export interface State {
  req_type: UserRequirementType;
  roles: {
    [key: number]: RoleConfig;
  };
}

export type Action =
  | { type: 'EXCLUDE_ROLE'; id_role: number }
  | { type: 'EXCLUDE_USER'; id_user: number }
  | { type: 'INCLUDE_ROLE'; id_role: number }
  | { type: 'INCLUDE_USER'; id_user: number }
  | { type: 'TOGGLE_REQ_TYPE'; value: UserRequirementType }
  | { type: 'UNINCLUDE_ROLE'; id_role: number }
  | { type: 'UNINCLUDE_USER'; id_user: number }
  | {
      type: 'UPDATE_ROLE_REQS';
      id_role: number;
      payload: {
        min_slots?: number;
        max_slots?: number;
        min_duration?: number;
        max_duration?: number;
        min_counter_unit?: number;
        max_counter_unit?: number;
      };
    }
  | {
      type: 'UPDATE_USER_REQS';
      id_user: number;
      payload: {
        min_slots?: number;
        max_slots?: number;
        min_duration?: number;
        max_duration?: number;
        min_counter_unit?: number;
        max_counter_unit?: number;
      };
    }
  | { type: 'INCLUDE_ALL' }
  | { type: 'UNINCLUDE_ALL' };

export type RuleWithInclusionType = Rule & {
  inclusionType: UserRequirementInclusionType;
};

export type MultipleUsersRuleType = Record<number, RuleWithInclusionType>;

export type SingleUserRuleType = Record<
  number,
  (Rule & {
    inclusionType: UserRequirementInclusionType;
    min_slots: number | null;
    max_slots: number | null;
    min_duration: number | null;
    max_duration: number | null;
    min_counter_unit: number | null;
    max_counter_unit: number | null;
  })[]
>;

export enum RuleTabType {
  INCLUSION = 'inclusion',
  EXCLUSION = 'exclusion',
  UNINCLUSION = 'uninclusion',
}
